import Vue from 'vue'
import {createApi} from 'unsplash-js'

Vue.prototype.$unsplash = createApi({
  accessKey: 'uTV774ZiB8EUDSwn8lRafX93WRBar7opjsN24ydVJKA'
})
